import { Icons } from '@/assets/icons/icons';
import { XStack, YStack } from '@/components/ui';
import { Button } from '@/components/ui/Button';

import { MEETING_TRIGGER_COPY } from '../routine-meeting-triggers';

import { RoutineMeetingFilterInput } from './routine-meeting-filter-input';

import type { MeetingTriggerDraft } from '@littlebird/sdk';

export function RoutineMeetingTriggerRow({
  trigger,
  onChange,
  onRemove,
}: {
  trigger: MeetingTriggerDraft;
  onChange: (trigger: MeetingTriggerDraft) => void;
  onRemove: () => void;
}) {
  const copy = MEETING_TRIGGER_COPY[trigger.kind];

  return (
    <YStack
      role="group"
      aria-label={copy.groupLabel}
      className="gap-2 rounded-xl border border-border bg-surface px-3 py-2"
    >
      <XStack className="min-h-10 items-center gap-2">
        <XStack
          center
          className="size-8 shrink-0 rounded-full bg-foreground-muted"
        >
          <copy.icon className="size-4 text-background" />
        </XStack>
        <span className="flex-1 text-sm">{copy.title}</span>
        <Button
          aria-label={`Remove ${copy.groupLabel.toLowerCase()}`}
          variant="ghost"
          size="icon-sm"
          iconOnly
          className="shrink-0 text-foreground-muted"
          onClick={onRemove}
        >
          <Icons.trash2 />
        </Button>
      </XStack>
      <RoutineMeetingFilterInput
        label="Title contains"
        placeholder="any title"
        values={trigger.titleContains}
        onValuesChange={(titleContains) =>
          onChange({ ...trigger, titleContains })
        }
      />
      <RoutineMeetingFilterInput
        label="Attendee emails"
        placeholder="anyone"
        values={trigger.attendeeEmails}
        separator=","
        onValuesChange={(attendeeEmails) =>
          onChange({ ...trigger, attendeeEmails })
        }
      />
      <RoutineMeetingFilterInput
        label="Attendee domains"
        placeholder="any domain"
        values={trigger.attendeeDomains}
        separator=","
        onValuesChange={(attendeeDomains) =>
          onChange({ ...trigger, attendeeDomains })
        }
      />
      <p className="text-xs text-foreground-muted">
        Attendee filters only match meetings on your calendar.
      </p>
    </YStack>
  );
}
